export default __webpack_public_path__ + "static/media/teaching-bg.9062be19.webp";